import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/blade-loanSecurityDeptService/loanSecurityDeptService/page',
        method: 'post',
        data: {
            ...params,
            current,
            size
        }
    })
}

export const remove = (id) => {
    return request({
        url: '/api/blade-loanSecurityDeptService/loanSecurityDeptService/remove',
        method: 'post',
        data: {
            id,
        }
    })
}

export const add = (row) => {
    return request({
        url: '/api/blade-loanSecurityDeptService/loanSecurityDeptService/saveOrUpdate',
        method: 'post',
        data: row
    })
}

export const update = (row) => {
    return request({
        url: '/api/blade-loanSecurityDeptService/loanSecurityDeptService/saveOrUpdate',
        method: 'post',
        data: row
    })
}

export const updateServiceBond = (row) => {
    return request({
        url: '/api/blade-loanSecurityDeptService/loanSecurityDeptService/updateSecurity',
        method: 'post',
        data: row
    })
}


export const exportData = (data) => {
    return request({
        url: `/api/blade-loanSecurityDeptService/loanSecurityDeptService/export-loanSecurityDeptFollow`,
        method: "post",
        responseType: 'blob',
        data: data,
    });
}